import axios from "../httpHandler";

export const getLogs = async (userId, currentPage, exportMode = false) => {
    try {
        const pageFilter = currentPage ? `&page=${currentPage}` : '';
        const exportFilter = exportMode ? `&excel=true` : '';
        const result = await axios.get(`logs?user_id=${userId}${pageFilter}${exportFilter}`);
        return result?.data;
    } catch (error) {
        throw error;
    }
};

export const getLogDetails = async (logId) => {
    try {
        const result = await axios.get(`logs/${logId}`);
        return result?.data;
    } catch (error) {
        throw error;
    }
};